import { getObbBettingLegs } from "@ppb/tbd-store/state/betting/obb-betting/obb-betting-selectors";
import { getSportsbookBettingLegs } from "@ppb/tbd-store/state/betting/sportsbook-betting/sportsbook-betting-selectors";
import { BetslipType } from "../../constants";
import { BetslipApplicationState } from "./BetslipApplicationState";
import { getObbReport, getSportsbookReport } from "./betslip-module/betslip-module-selectors";

const hasLegs = (legs: object | undefined): boolean => !!legs && Object.keys(legs).length > 0;

export const getActiveBetslipType = (state: BetslipApplicationState): BetslipType | null => {
  if (state.betslipModule?.step === "REPORT") {
    if (getObbReport(state)) {
      return BetslipType.OBB;
    }

    if (getSportsbookReport(state)) {
      return BetslipType.SPORTSBOOK;
    }
  }

  if (hasLegs(getObbBettingLegs(state))) {
    return BetslipType.OBB;
  }

  if (hasLegs(getSportsbookBettingLegs(state))) {
    return BetslipType.SPORTSBOOK;
  }

  return null;
};
